export default __webpack_public_path__ + "static/media/left2.c86eabe4.svg";